var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.146.782c-1.101-1.043-3.022-1.043-4.124 0l-9.78 9.252a.68.68 0 0 0-.19.32l-1.03 3.9a.669.669 0 0 0 .191.655.75.75 0 0 0 .692.181l4.123-.975a.732.732 0 0 0 .338-.181l9.78-9.252c.55-.52.854-1.214.854-1.95a2.66 2.66 0 0 0-.854-1.95ZM4.479 12.824l-2.749.65.687-2.6 8.09-7.654 2.062 1.95-8.09 7.654Zm9.636-9.117-.515.487-2.062-1.951.515-.487c.55-.52 1.511-.52 2.062 0 .275.26.427.606.427.975 0 .37-.152.715-.427.976Z",
    fill: "#1F1F1F",
    fillOpacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15.111,
    width: 16,
    height: 0.889,
    rx: 0.444,
    fill: "#1F1F1F",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.453d13811191cef09ff560c138210172.svg";
export { ForwardRef as ReactComponent };